import notify from 'devextreme/ui/notify';
import type { DiscussionPeerActivityEvent } from '@jarvis/platform-file-review';
import { formatDiscussionPeerActivityMessage } from './discussionNotificationCopy';

const DISCUSSION_TOAST_DISPLAY_MS = 10_000;

let toastAnchorSelector = '.app-shell-main';

export function configureDiscussionMessageToasts(anchorSelector: string): void {
  toastAnchorSelector = anchorSelector;
}

export function showDiscussionMessageToast(event: DiscussionPeerActivityEvent): void {
  notify({
    message: formatDiscussionPeerActivityMessage(event),
    type: 'info',
    displayTime: DISCUSSION_TOAST_DISPLAY_MS,
    closeOnClick: true,
    width: 'auto',
    minWidth: 560,
    maxWidth: 760,
    position: {
      my: 'bottom right',
      at: 'bottom right',
      of: toastAnchorSelector,
      offset: '-16 -16'
    }
  });
}
